(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rs-enquiry-list"] && !Shopify.designMode) return;
  try {
    function rsSelectionFocusTarget(candidates) {
    return candidates.find(element => element?.isConnected && typeof element.focus === 'function' && !element.disabled && element.matches('a[href],button,input,select,textarea,[tabindex]') && !element.closest('[hidden],[inert],dialog:not([open])') && (typeof element.checkVisibility === 'function' ? element.checkVisibility({visibilityProperty:true}) : element.getClientRects().length > 0));
  }
  function rsSelectionIdValid(id) {
    return typeof id === 'string' && (/^[1-9]\d{0,19}$/.test(id) || /^RS\d{6}-[A-Z0-9-]{1,60}$/.test(id));
  }
  function rsSelectionItem(option, origin) {
    if (!option || !rsSelectionIdValid(option.value)) return null;
    const raw = option.dataset?.url;
    if (typeof raw !== 'string' || raw.length > 900 || /[\\\u0000-\u0020\u007f]/.test(raw)) return null;
    try {
      const url = new URL(raw, origin);
      if (url.origin !== origin || url.username || url.password || url.hash) return null;
      const isCatalogue = option.dataset.catalogueId === option.value && option.value.startsWith('RS');
      if (isCatalogue) {
        const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/(wholesale-range|wholesale-spices|services)$/);
        if (!match) return null;
        const params = url.searchParams;
        if ([...params.keys()].some(key => !['ingredient','form','q','view'].includes(key) || params.getAll(key).length !== 1)) return null;
        if (match[1] === 'services' ? params.get('view') !== 'wholesale-range' : params.has('view')) return null;
        const ingredient = params.get('ingredient');
        const form = params.get('form');
        if (ingredient !== null && (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(ingredient) || ingredient !== option.dataset.productHandle)) return null;
        if (form !== null && form !== option.value) return null;
        if (match[1] === 'wholesale-range' && (!ingredient || !form || params.has('q'))) return null;
        if (params.has('q') && (!params.get('q').trim() || params.get('q').length > 200 || /[\u0000-\u001f\u007f<>]/.test(params.get('q')))) return null;
        return {id:option.value, productId:option.dataset.productId, catalogueId:option.value, title:option.textContent.trim(), url:url.pathname + url.search};
      }
      if (!/^[1-9]\d{0,19}$/.test(option.value) || !/^[1-9]\d{0,19}$/.test(option.dataset.productId || '') || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/.test(url.pathname)) return null;
      return {id:option.value, productId:option.dataset.productId, catalogueId:'', title:option.textContent.trim(), url:url.pathname + '?variant=' + option.value};
    } catch { return null; }
  }
  function rsSelectionNormalize(value, catalogueIds) {
    if (!value || ![1,2].includes(value.version) || !Array.isArray(value.ids)) return [];
    const ids = [];
    for (const id of value.ids.slice(0, 100)) {
      if (!rsSelectionIdValid(id) || !catalogueIds.has(id) || ids.includes(id)) continue;
      ids.push(id);
      if (ids.length === 12) break;
    }
    return ids;
  }
  function rsSelectionRead(raw, catalogueIds) {
    if (typeof raw !== 'string' || raw.length > 5000) return [];
    try { return rsSelectionNormalize(JSON.parse(raw), catalogueIds); } catch { return []; }
  }
  function rsSelectionAppend(ids, id, catalogueIds) {
    const current = rsSelectionNormalize({version:2, ids}, catalogueIds);
    if (!rsSelectionIdValid(id) || !catalogueIds.has(id)) return {ids:current, result:'unavailable'};
    if (current.includes(id)) return {ids:current, result:'already'};
    if (current.length >= 12) return {ids:current, result:'full'};
    return {ids:[...current, id], result:'added'};
  }
  function rsSelectionLoad(getStorage, catalogueIds) {
    let ids = [];
    try {
      const storage = getStorage();
      ids = rsSelectionRead(storage.getItem('rehan-ingredient-list-v2') ?? storage.getItem('rehan-ingredient-list-v1'), catalogueIds);
      storage.setItem('rehan-ingredient-list-v2', JSON.stringify({version:2, ids}));
      storage.removeItem('rehan-ingredient-list-v1');
      return {ids, available:true};
    } catch { return {ids, available:false}; }
  }
  function rsSelectionCatalogueUrl(value, origin) {
    try {
      const url = new URL(value,origin);
      if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/all$/.test(url.pathname)) return null;
      url.search = '';
      url.hash = '';
      url.searchParams.set('view','rs-enquiry-catalogue');
      return url.pathname + url.search;
    } catch { return null; }
  }
  (async () => {
    const root = document.querySelector('[data-rs-selection-root]');
    if (!root || root.dataset.ready) return;
    const dialog = root.querySelector('[data-rs-selection-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    root.dataset.ready = 'true';
    let catalogueTemplate = root.querySelector('[data-rs-selection-catalogue="1"]');
    if (!catalogueTemplate?.content.querySelector('option')) {
      const sourceUrl = rsSelectionCatalogueUrl(root.dataset.catalogueUrl,window.location.origin);
      if (!sourceUrl) return;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(),8000);
      try {
        const response = await fetch(sourceUrl,{credentials:'same-origin',signal:controller.signal});
        if (!response.ok || new URL(response.url).origin !== window.location.origin) return;
        const html = await response.text();
        if (html.length > 1000000) return;
        const documentCopy = new DOMParser().parseFromString(html,'text/html');
        if (!documentCopy.querySelector('meta[name="rehan-enquiry-catalogue"][content="1"]')) return;
        const templates = documentCopy.querySelectorAll('template[data-rs-selection-catalogue="1"]');
        if (templates.length !== 1) return;
        catalogueTemplate = templates[0];
      } catch { return; } finally { clearTimeout(timer); }
    }
    const catalogue = new Map();
    catalogueTemplate.content.querySelectorAll('option').forEach(option => {
      const item = rsSelectionItem(option, window.location.origin);
      if (item) catalogue.set(item.id, item);
    });
    const catalogueIds = new Set(catalogue.keys());
    if (!catalogueIds.size) return;
    const storageKey = 'rehan-ingredient-list-v2';
    const saved = rsSelectionLoad(() => sessionStorage, catalogueIds);
    let storageAvailable = saved.available;
    let ids = saved.ids;
    const items = root.querySelector('[data-rs-selection-items]');
    const itemTemplate = root.querySelector('[data-rs-selection-item]');
    const toast = root.querySelector('[data-rs-selection-toast]');
    const continueLink = root.querySelector('[data-rs-selection-continue]');
    const requestUrl = new URL(continueLink.href, window.location.origin);
    let opener = null;
    const message = key => root.getAttribute('data-message-' + key.replaceAll('_','-')) || '';
    const labelled = (key,title) => message(key).replace('__TITLE__',title || '');
    function save() {
      if (!storageAvailable) return;
      try { sessionStorage.setItem(storageKey, JSON.stringify({version:2, ids})); } catch { storageAvailable = false; }
    }
    function chosen(control) {
      if (control.hasAttribute('data-use-product-selector')) return control.closest('[data-rs-product]')?.querySelector('[data-rs-variant-select]')?.value || control.dataset.defaultVariant;
      return control.querySelector('[data-rs-selection-variant]')?.value ?? control.dataset.defaultVariant;
    }
    function updateControls() {
      document.querySelectorAll('[data-rs-selection-open]').forEach(button => { button.hidden = false; });
      document.querySelectorAll('[data-rs-selection-count]').forEach(count => { count.textContent = String(ids.length); });
      document.querySelectorAll('[data-rs-selection-add]').forEach(control => {
        control.hidden = false;
        const included = ids.includes(chosen(control));
        const label = control.querySelector('[data-rs-selection-add-text]');
        const button = control.querySelector('[data-rs-selection-add-button]');
        if (label) label.textContent = message(included ? 'added_button' : 'add');
        if (button) button.setAttribute('data-in-list',String(included));
      });
    }
    function render() {
      items.replaceChildren();
      ids.forEach(id => {
        const product = catalogue.get(id);
        const item = itemTemplate.content.firstElementChild.cloneNode(true);
        const link = item.querySelector('[data-rs-selection-item-link]');
        link.textContent = product.title;
        link.href = product.url;
        const remove = item.querySelector('[data-rs-selection-remove]');
        remove.dataset.rsSelectionRemove = id;
        remove.setAttribute('aria-label',labelled('remove_named',product.title));
        items.append(item);
      });
      root.querySelector('[data-rs-selection-empty]').hidden = ids.length !== 0;
      root.querySelector('[data-rs-selection-filled]').hidden = ids.length === 0;
      root.querySelector('[data-rs-selection-storage]').hidden = storageAvailable;
      root.querySelector('[data-rs-selection-summary]').textContent = message('count').replace('__COUNT__',String(ids.length));
      const url = new URL(requestUrl);
      url.searchParams.set('from_list','1');
      url.searchParams.delete('list_variants');
      url.searchParams.set('list_items',ids.join(','));
      continueLink.href = url.pathname + url.search;
      updateControls();
    }
    function announce(text) {
      if (dialog.open) root.querySelector('[data-rs-selection-dialog-status]').textContent = text;
      else {
        toast.hidden = false;
        root.querySelector('[data-rs-selection-status]').textContent = text;
      }
    }
    function open(trigger) {
      opener = rsSelectionFocusTarget([trigger,document.activeElement,...document.querySelectorAll('[data-rs-selection-open]')]);
      toast.hidden = true;
      root.querySelector('[data-rs-selection-dialog-status]').textContent = '';
      render();
      if (!dialog.open) dialog.showModal();
    }
    document.addEventListener('click',event => {
      const trigger = event.target.closest('[data-rs-selection-open]');
      if (trigger) { open(trigger); return; }
      const button = event.target.closest('[data-rs-selection-add-button]');
      if (!button) return;
      const control = button.closest('[data-rs-selection-add]');
      const id = chosen(control);
      if (!id) {
        announce(message('choose_notice'));
        control.querySelector('[data-rs-selection-variant]')?.focus();
        return;
      }
      const product = catalogue.get(id);
      const allowedControl = control.dataset.catalogueControl === 'true' ? product?.catalogueId === id : product?.productId && product.productId === control.dataset.productId;
      if (!allowedControl) { announce(message('unavailable')); return; }
      const result = rsSelectionAppend(ids,id,catalogueIds);
      ids = result.ids;
      save();
      render();
      announce(labelled(result.result,product?.title));
      if (!storageAvailable) { open(button); announce(message('storage_short')); }
    });
    document.addEventListener('change',event => {
      if (event.target.matches('[data-rs-selection-variant],[data-rs-variant-select]')) updateControls();
    });
    document.addEventListener('rs:selection-controls-update',updateControls);
    document.addEventListener('rs:selection-submitted',event => {
      if (!Array.isArray(event.detail?.ids)) return;
      const submitted = new Set(event.detail.ids.filter(id => catalogueIds.has(id)));
      ids = ids.filter(id => !submitted.has(id));
      save();
      render();
    });
    root.querySelector('[data-rs-selection-close]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('close',() => {
      const target = rsSelectionFocusTarget([opener,...document.querySelectorAll('[data-rs-selection-open]')]);
      target?.focus();
    });
    dialog.addEventListener('click',event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    root.querySelector('[data-rs-selection-clear]').addEventListener('click',() => {
      ids = [];
      save();
      render();
      root.querySelector('[data-rs-selection-close]').focus();
      announce(message('cleared'));
    });
    items.addEventListener('click',event => {
      const button = event.target.closest('[data-rs-selection-remove]');
      if (!button) return;
      const id = button.dataset.rsSelectionRemove;
      const index = ids.indexOf(id);
      const title = catalogue.get(id)?.title;
      ids = ids.filter(value => value !== id);
      save();
      render();
      const removes = items.querySelectorAll('[data-rs-selection-remove]');
      (removes[Math.min(index,removes.length - 1)] || root.querySelector('[data-rs-selection-close]')).focus();
      announce(labelled('removed',title));
    });
    root.querySelector('[data-rs-selection-dismiss]').addEventListener('click',() => {
      toast.hidden = true;
      rsSelectionFocusTarget([...document.querySelectorAll('[data-rs-selection-open]')])?.focus();
    });
    document.addEventListener('shopify:section:load',updateControls);
    window.addEventListener('pageshow',event => {
      if (!event.persisted || !storageAvailable) return;
      const restored = rsSelectionLoad(() => sessionStorage, catalogueIds);
      ids = restored.ids;
      storageAvailable = restored.available;
      render();
    });
    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-enquiry-source"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeEnquirySources() {
    if (window.rehanEnquirySourcesReady) return;
    window.rehanEnquirySourcesReady = true;
    const params = new URLSearchParams(location.search);
    const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
    const values = {};
    keys.forEach(key => {
      const value = params.get(key);
      if (value && /^[a-zA-Z0-9_. -]{1,100}$/.test(value)) values[key] = value;
    });
    let landing = '';
    const candidate = params.get('rs_landing');
    if (candidate && /^\/[a-zA-Z0-9_\/-]{0,200}$/.test(candidate) && !candidate.startsWith('//')) landing = candidate;
    if (!landing && Object.keys(values).length) landing = location.pathname.slice(0,200);
    function analyticsAllowed() {
      try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch { return false; }
    }
    function contactForms(scope) {
      const forms = [...scope.querySelectorAll('[data-rs-contact] form')];
      if (scope.matches?.('form') && scope.closest('[data-rs-contact]')) forms.push(scope);
      if (scope.matches?.('[data-rs-contact]')) forms.push(...scope.querySelectorAll('form'));
      return [...new Set(forms)];
    }
    function fillSources(scope) {
      const allowed = analyticsAllowed();
      contactForms(scope).forEach(form => {
        const fields = {enquiry_page:location.pathname};
        const application = params.get('application');
        if (application && /^[a-z0-9-]{1,100}$/.test(application)) fields['Recipe or application'] = application;
        if (allowed) Object.assign(fields,values,landing ? {landing_page:landing} : {});
        [...keys,'landing_page'].forEach(key => {
          const input = form.elements.namedItem('contact[' + key + ']');
          if (input && !allowed) { input.value = ''; input.setAttribute('value',''); }
        });
        Object.entries(fields).forEach(([key,value]) => {
          let input = form.elements.namedItem('contact[' + key + ']');
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'contact[' + key + ']'; input.dataset.rsSource = key; form.appendChild(input); }
          input.value = value;
          input.setAttribute('value',value);
        });
      });
    }
    function decorateLink(anchor) {
      const href = anchor?.getAttribute('href');
      if (!href || anchor.hasAttribute('download') || href.startsWith('#')) return;
      try {
        const url = new URL(anchor.href,location.origin);
        if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return;
        const allowed = analyticsAllowed();
        if (!allowed) [...keys,'rs_landing'].forEach(key => url.searchParams.delete(key));
        else if (!/^\/(cart|checkout|account)(\/|$)/.test(url.pathname)) {
          Object.entries(values).forEach(([key,value]) => { if (!url.searchParams.has(key)) url.searchParams.set(key,value); });
          if (landing && !url.searchParams.has('rs_landing')) url.searchParams.set('rs_landing',landing);
        }
        if (anchor.href !== url.href) anchor.href = url.href;
      } catch {}
    }
    function decorateSearch(form) {
      try {
        const action = new URL(form.action,location.origin);
        if (action.origin !== location.origin || !action.pathname.endsWith('/search')) return;
        const allowed = analyticsAllowed();
        const searchValues = allowed ? {...values,...(landing ? {rs_landing:landing} : {})} : {};
        [...keys,'rs_landing'].forEach(name => {
          const field = form.elements.namedItem(name);
          if (!allowed && field?.type === 'hidden') field.remove();
          if (!allowed) action.searchParams.delete(name);
        });
        if (!allowed && form.action !== action.href) form.action = action.href;
        Object.entries(searchValues).forEach(([name,value]) => {
          if (form.elements.namedItem(name)) return;
          const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; form.appendChild(input);
        });
      } catch {}
    }
    function decorateScope(scope) {
      if (scope.matches?.('a[href]')) decorateLink(scope);
      scope.querySelectorAll?.('a[href]').forEach(decorateLink);
      if (scope.matches?.('form[method="get"],form[method="GET"]')) decorateSearch(scope);
      scope.querySelectorAll?.('form[method="get"],form[method="GET"]').forEach(decorateSearch);
    }
    function clearLegacyAttribution() {
      if (analyticsAllowed()) return;
      try {
        const key = 'rehan-enquiry-recovery';
        const recovery = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (!recovery?.values) return;
        [...keys,'landing_page'].forEach(name => delete recovery.values['contact[' + name + ']']);
        const productLink = recovery.values['contact[product_url]'];
        if (typeof productLink === 'string' && productLink) {
          try {
            const cleanUrl = new URL(productLink,location.origin);
            [...keys,'rs_landing'].forEach(name => cleanUrl.searchParams.delete(name));
            recovery.values['contact[product_url]'] = cleanUrl.href;
          } catch {}
        }
        sessionStorage.setItem(key,JSON.stringify(recovery));
      } catch {}
    }
    function update(scope = document) { fillSources(scope); decorateScope(scope); clearLegacyAttribution(); }
    update();
    document.addEventListener('visitorConsentCollected', () => update());
    document.addEventListener('shopify:section:load', event => update(event.target));
    document.addEventListener('click', event => decorateLink(event.target.closest('a[href]')),true);
    document.addEventListener('submit', event => { if (event.target.matches('form')) { fillSources(event.target); decorateSearch(event.target); } },true);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') decorateLink(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) update(node); });
    })).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href']});
    window.addEventListener('pageshow', () => update());
    if (window.Shopify?.customerPrivacy) return;
    if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
      update();
      if (!error && window.Shopify?.customerPrivacy) document.dispatchEvent(new CustomEvent('rehan:privacy-ready'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeEnquirySources,{once:true});
  else initializeEnquirySources();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-global"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-rs-enquire]');
  if (!trigger || !trigger.dataset.productTitle) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = new URL(trigger.href || '/pages/contact', window.location.origin);
  target.searchParams.set('product', trigger.dataset.productTitle);
  if (trigger.dataset.variantTitle) target.searchParams.set('variant', trigger.dataset.variantTitle);
  if (trigger.dataset.quantity) target.searchParams.set('quantity', trigger.dataset.quantity);
  if (trigger.dataset.productUrl) target.searchParams.set('product_url', trigger.dataset.productUrl);
  trigger.href = target.pathname + target.search;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-ingredient-directory"] && !Shopify.designMode) return;
  try {
    (() => {
  const synonyms = {molido:'ground',molida:'ground',molidos:'ground',molidas:'ground',entero:'whole',entera:'whole',enteros:'whole',enteras:'whole',quebrado:'cracked',quebrada:'cracked',polvo:'powder'};
  const tokenize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().match(/[\p{L}\p{N}]+(?:[./][\p{L}\p{N}]+)*/gu)?.map(word => synonyms[word] || word) || [];
  const matchingRows = (entries, query, category) => {
    const terms = tokenize(query);
    const hasQuery = Boolean(String(query || '').trim());
    return entries.map(entry => ({entry, rows: entry.rows.filter(row => (!category || entry.category === category) && (!hasQuery || (terms.length > 0 && terms.every(term => row.words.some(word => word.startsWith(term))))))}));
  };
  const initialize = container => {
    container.querySelectorAll('[data-ingredient-directory]').forEach(root => {
      if (root.dataset.directoryReady) return;
      root.dataset.directoryReady = 'true';
      const search = root.querySelector('[data-dir-search]');
      const category = root.querySelector('[data-dir-category]');
      const controls = root.querySelector('[data-dir-controls]');
      const count = root.querySelector('[data-dir-count]');
      const empty = root.querySelector('[data-dir-empty]');
      const reset = controls.querySelector('[data-dir-reset]');
      const groups = [...root.querySelectorAll('[data-dir-group]')];
      const letterLinks = [...root.querySelectorAll('[data-dir-letter]')];
      const entries = [...root.querySelectorAll('[data-dir-entry]')].map(element => ({element, category:element.dataset.category, details:element.querySelector('[data-dir-details]'), rows:[...element.querySelectorAll('[data-dir-row]')].map(row => ({element:row, words:tokenize(row.dataset.search)}))}));
      const update = writeUrl => {
        const matches = matchingRows(entries, search.value, category.value);
        let families = 0;
        let forms = 0;
        matches.forEach(({entry,rows}) => {
          const selected = new Set(rows);
          entry.element.hidden = !rows.length;
          entry.rows.forEach(row => {row.element.hidden = !selected.has(row);});
          if (entry.details) entry.details.open = Boolean(search.value.trim()) && rows.length > 0;
          if (rows.length) {families += 1; forms += rows.length;}
        });
        groups.forEach(group => {group.hidden = !group.querySelector('[data-dir-entry]:not([hidden])');});
        letterLinks.forEach(link => {
          const group = groups.find(item => item.dataset.dirGroup === link.dataset.dirLetter);
          const disabled = !group || group.hidden;
          link.setAttribute('aria-disabled', String(disabled));
          if (disabled) link.setAttribute('tabindex','-1'); else link.removeAttribute('tabindex');
        });
        count.textContent = root.dataset.countTemplate.replace('__FAMILIES__',String(families)).replace('__FORMS__',String(forms));
        empty.hidden = forms > 0;
        reset.hidden = !search.value.trim() && !category.value;
        if (writeUrl) {
          const url = new URL(window.location.href);
          const term = search.value.trim();
          if (term) url.searchParams.set('q',term); else url.searchParams.delete('q');
          if (category.value) url.searchParams.set('category',category.value); else url.searchParams.delete('category');
          url.searchParams.delete('rs_query');
          history.replaceState(null,'',url);
        }
      };
      const readLocation = () => {
        const params = new URLSearchParams(window.location.search);
        search.value = params.get('q') || '';
        const chosenCategory = params.get('category') || '';
        category.value = [...category.options].some(option => option.value === chosenCategory) ? chosenCategory : '';
      };
      readLocation();
      if (root.dataset.initialQuery) search.value = root.dataset.initialQuery;
      controls.hidden = false;
      controls.addEventListener('submit',event => {event.preventDefault();update(true);});
      search.addEventListener('input',() => update(true));
      category.addEventListener('change',() => update(true));
      root.querySelectorAll('[data-dir-reset]').forEach(button => button.addEventListener('click',() => {search.value='';category.value='';update(true);search.focus();}));
      letterLinks.forEach(link => link.addEventListener('click',event => {
        if (link.getAttribute('aria-disabled') === 'true') {event.preventDefault();return;}
        const group = groups.find(item => item.dataset.dirGroup === link.dataset.dirLetter);
        if (group) group.focus({preventScroll:true});
      }));
      window.addEventListener('popstate',() => {readLocation();update(false);});
      update(false);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-policy-document"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializePolicies(scope) {
    scope.querySelectorAll('[data-rs-policy]').forEach(policy => {
      if (policy.dataset.ready) return;
      policy.dataset.ready = 'true';
      const print = policy.querySelector('[data-rs-policy-print]');
      if (print) { print.hidden = false; print.addEventListener('click', () => window.print()); }
      const contents = policy.querySelector('[data-rs-policy-contents]');
      if (contents && window.matchMedia('(max-width:700px)').matches) contents.open = false;
      const feedback = policy.querySelector('[data-rs-policy-feedback]');
      if (feedback) feedback.focus();
      const requestKind = policy.querySelector('[data-rs-privacy-request-kind]');
      if (requestKind && [...requestKind.options].some(option => option.value === requestKind.dataset.rsPrivacyRequestKind)) requestKind.value = requestKind.dataset.rsPrivacyRequestKind;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializePolicies(document), {once:true});
  else initializePolicies(document);
  document.addEventListener('shopify:section:load', event => initializePolicies(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-privacy-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.rehanPrivacyReady) return;
  window.rehanPrivacyReady = true;
  let apiPromise;
  let opener;
  const getDialog = () => document.querySelector('[data-rs-privacy-dialog]');
  function loadApi() {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('unavailable')), 10000);
      if (!window.Shopify?.loadFeatures) { clearTimeout(timer); reject(new Error('unavailable')); return; }
      window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.1' }], (error) => {
        clearTimeout(timer);
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch((error) => { apiPromise = undefined; throw error; });
    return apiPromise;
  }
  function sync(dialog, api) {
    const current = api.currentVisitorConsent();
    ['preferences','analytics','marketing'].forEach((key) => { dialog.querySelector('[name="' + key + '"]').checked = current[key] === 'yes'; });
    let blocked;
    try { blocked = api.saleOfDataAllowed?.() === false; } catch { blocked = undefined; }
    const signal = navigator.globalPrivacyControl === true;
    let signalRegion = false;
    try { signalRegion = api.saleOfDataRegion?.() === true; } catch {}
    let text = current.sale_of_data === 'no' ? dialog.dataset.optedOut : blocked ? dialog.dataset.saleBlocked : dialog.dataset.saleNotRecorded;
    if (signal) text += ' ' + (blocked && signalRegion ? dialog.dataset.gpcHonored : dialog.dataset.gpcUnconfirmed);
    dialog.querySelector('[data-rs-privacy-sale-state]').textContent = text;
  }
  async function prepare(dialog) {
    const status = dialog.querySelector('[data-rs-privacy-status]');
    dialog.querySelector('[data-rs-privacy-fields]').disabled = true;
    dialog.querySelector('[data-rs-privacy-retry]').hidden = true;
    status.textContent = dialog.dataset.loading;
    try {
      const api = await loadApi();
      sync(dialog, api);
      dialog.querySelector('[data-rs-privacy-fields]').disabled = false;
      status.textContent = '';
    } catch {
      status.textContent = dialog.dataset.error;
      dialog.querySelector('[data-rs-privacy-sale-state]').textContent = dialog.dataset.saleUnknown;
      dialog.querySelector('[data-rs-privacy-retry]').hidden = false;
    }
  }
  async function save(dialog, consent) {
    const previousFocus = document.activeElement;
    const fields = dialog.querySelector('[data-rs-privacy-fields]');
    const status = dialog.querySelector('[data-rs-privacy-status]');
    fields.disabled = true;
    status.textContent = dialog.dataset.loading;
    try {
      const api = await loadApi();
      await new Promise((resolve,reject) => {
        const timer = setTimeout(() => reject(new Error('unavailable')),10000);
        api.setTrackingConsent(consent, () => {
          clearTimeout(timer);
          const state = api.currentVisitorConsent();
          const saved = Object.entries(consent).every(([key,value]) => state[key] === (value ? 'yes' : 'no'));
          if (saved) resolve(); else reject(new Error('not confirmed'));
        });
      });
      sync(dialog,api);
      status.textContent = consent.sale_of_data === false && consent.analytics === false ? dialog.dataset.rejected : consent.sale_of_data === false ? dialog.dataset.optedOut : dialog.dataset.saved;
    } catch { status.textContent = dialog.dataset.error; }
    finally {
      fields.disabled = false;
      if (dialog.open && previousFocus?.isConnected && (document.activeElement === document.body || document.activeElement === dialog)) previousFocus.focus();
    }
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rs-privacy-open]');
    const dialog = getDialog();
    if (!dialog) return;
    if (trigger) {
      event.preventDefault(); opener = trigger;
      if (!dialog.open) dialog.showModal();
      prepare(dialog);
    }
    if (event.target.closest('[data-rs-privacy-close]')) dialog.close();
    if (event.target.closest('[data-rs-privacy-retry]')) prepare(dialog);
    if (event.target.closest('[data-rs-privacy-reject]')) save(dialog,{preferences:false,analytics:false,marketing:false,sale_of_data:false});
    if (event.target.closest('[data-rs-privacy-optout]')) save(dialog,{sale_of_data:false});
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-rs-privacy-form]')) return;
    event.preventDefault();
    const dialog=getDialog();
    save(dialog,Object.fromEntries(['preferences','analytics','marketing'].map(key=>[key,event.target.elements[key].checked])));
  });
  document.addEventListener('close', (event) => { if (event.target.matches('[data-rs-privacy-dialog]') && opener?.isConnected) opener.focus(); },true);
  document.addEventListener('visitorConsentCollected', () => {
    const dialog = getDialog();
    if (!dialog?.open || !window.Shopify?.customerPrivacy) return;
    try { sync(dialog,window.Shopify.customerPrivacy); } catch { dialog.querySelector('[data-rs-privacy-sale-state]').textContent = dialog.dataset.saleUnknown; }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-product-catalogue-bridge"] && !Shopify.designMode) return;
  try {
    function rsUpdateProductBridge(productSection, announce = false) {
    const bridge = productSection.querySelector('[data-rs-product-bridge]');
    if (!bridge) return;
    const view = bridge.querySelector('[data-rs-bridge-view]');
    if (!view) return;
    const selector = productSection.querySelector('[data-rs-variant-select]');
    const variantId = selector ? selector.value : bridge.dataset.initialVariant;
    const template = /^[1-9]\d{0,19}$/.test(variantId || '') && Array.from(bridge.querySelectorAll('template[data-rs-bridge-variant]')).find(item => item.dataset.rsBridgeVariant === variantId);
    const selected = template || bridge.querySelector('template[data-rs-bridge-fallback]');
    if (!selected) return;
    view.replaceChildren(selected.content.cloneNode(true));
    if (announce) {
      const status = bridge.querySelector('[data-rs-bridge-status]');
      if (status) status.textContent = view.querySelector('[data-rs-bridge-label]')?.dataset.rsBridgeLabel || '';
    }
  }
  function rsInitializeProductBridges(root) {
    root.querySelectorAll('[data-rs-product]').forEach(productSection => rsUpdateProductBridge(productSection));
  }
  rsInitializeProductBridges(document);
  document.addEventListener('shopify:section:load', event => rsInitializeProductBridges(event.target));
  document.addEventListener('change', event => {
    const selector = event.target.closest('[data-rs-variant-select]');
    const productSection = selector?.closest('[data-rs-product]');
    if (productSection) rsUpdateProductBridge(productSection, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-product-gallery"] && !Shopify.designMode) return;
  try {
    function rsGalleryFit(gallery) {
    const fits = window.innerWidth >= 1000 && window.innerHeight >= 650 && gallery.getBoundingClientRect().height <= window.innerHeight - 48;
    gallery.classList.toggle('rs-gallery--sticky', fits);
  }
  function rsSelectGallery(gallery, id, announce = false) {
    const panels = [...gallery.querySelectorAll('[data-rs-gallery-panel]')];
    const active = panels.find(panel => panel.dataset.rsGalleryPanel === id);
    if (!active) return false;
    panels.forEach(panel => {
      panel.hidden = panel !== active;
      if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-rs-gallery-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rsGallerySelect === id)));
    gallery.dataset.rsGalleryActive = id;
    const current = gallery.querySelector('[data-rs-gallery-current]');
    if (current) current.textContent = String(panels.indexOf(active) + 1).padStart(2, '0');
    if (announce) {
      const status = gallery.querySelector('[data-rs-gallery-status]');
      const selected = [...gallery.querySelectorAll('[data-rs-gallery-select]')].find(button => button.dataset.rsGallerySelect === id);
      if (status) status.textContent = selected?.getAttribute('aria-label') || active.querySelector('figcaption')?.textContent || '';
    }
    rsGalleryFit(gallery);
    return true;
  }
  function rsGalleryVariant(gallery, id) {
    if (id && rsSelectGallery(gallery, id)) return;
    const fallback = gallery.querySelector('[data-rs-gallery-panel="editorial"]') || gallery.querySelector('[data-rs-gallery-panel]');
    if (fallback) rsSelectGallery(gallery, fallback.dataset.rsGalleryPanel);
  }
  function rsUpdateGalleryZoom(gallery, link) {
    const dialog = gallery.querySelector('[data-rs-zoom-dialog]');
    const image = dialog?.querySelector('[data-rs-zoom-image]');
    if (!image || !link) return false;
    const panel = link.closest('[data-rs-gallery-panel]');
    const imageLinks = [...gallery.querySelectorAll('[data-rs-gallery-panel] [data-rs-zoom]')];
    image.src = link.href;
    image.alt = link.querySelector('img')?.alt || '';
    const index = imageLinks.indexOf(link);
    dialog.dataset.rsZoomIndex = String(index);
    dialog.querySelector('[data-rs-zoom-caption]').textContent = panel.querySelector('figcaption')?.textContent || '';
    dialog.querySelector('[data-rs-zoom-count]').textContent = `${index + 1} / ${imageLinks.length}`;
    dialog.querySelector('[data-rs-zoom-nav]').hidden = imageLinks.length < 2;
    rsSelectGallery(gallery, panel.dataset.rsGalleryPanel);
    return true;
  }
  function rsStepGalleryZoom(dialog, step) {
    const gallery = dialog.closest('[data-rs-gallery]');
    const imageLinks = [...gallery.querySelectorAll('[data-rs-gallery-panel] [data-rs-zoom]')];
    if (imageLinks.length < 2) return;
    const index = (Number(dialog.dataset.rsZoomIndex || 0) + step + imageLinks.length) % imageLinks.length;
    rsUpdateGalleryZoom(gallery, imageLinks[index]);
  }
  function rsInitGalleries(root) {
    root.querySelectorAll('[data-rs-gallery]').forEach(gallery => {
      if (gallery.hasAttribute('data-rs-gallery-ready')) return;
      gallery.setAttribute('data-rs-gallery-ready', '');
      const panels = [...gallery.querySelectorAll('[data-rs-gallery-panel]')];
      const thumbnails = gallery.querySelector('[data-rs-gallery-thumbnails]');
      if (thumbnails) thumbnails.hidden = panels.length < 2;
      rsGalleryVariant(gallery, gallery.dataset.rsGalleryInitial);
      gallery.querySelector('[data-rs-zoom-dialog]')?.addEventListener('close', () => {
        const active = [...gallery.querySelectorAll('[data-rs-gallery-panel]')].find(panel => !panel.hidden);
        active?.querySelector('[data-rs-zoom]')?.focus({ preventScroll: true });
      });
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => rsGalleryFit(gallery));
        observer.observe(gallery);
        gallery.rsGalleryObserver = observer;
      }
    });
  }
  rsInitGalleries(document);
  document.addEventListener('shopify:section:load', event => rsInitGalleries(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rs-gallery]').forEach(gallery => gallery.rsGalleryObserver?.disconnect()));
  window.addEventListener('resize', () => document.querySelectorAll('[data-rs-gallery]').forEach(rsGalleryFit), { passive: true });
  document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-rs-gallery-select]');
    if (thumb) rsSelectGallery(thumb.closest('[data-rs-gallery]'), thumb.dataset.rsGallerySelect, true);
    const zoomLink = event.target.closest('[data-rs-zoom]');
    if (zoomLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const gallery = zoomLink.closest('[data-rs-gallery]');
      const dialog = gallery.querySelector('[data-rs-zoom-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function' || !rsUpdateGalleryZoom(gallery, zoomLink)) return;
      event.preventDefault();
      dialog.showModal();
    }
    const step = event.target.closest('[data-rs-zoom-step]');
    if (step) rsStepGalleryZoom(step.closest('[data-rs-zoom-dialog]'), Number(step.dataset.rsZoomStep));
    const closeButton = event.target.closest('[data-rs-close-zoom]');
    if (closeButton) closeButton.closest('dialog').close();
    if (event.target.matches('[data-rs-zoom-dialog]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    const dialog = event.target.closest('[data-rs-zoom-dialog]');
    if (dialog?.open && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault();
      rsStepGalleryZoom(dialog, event.key === 'ArrowLeft' ? -1 : 1);
      return;
    }
    const thumb = event.target.closest('[data-rs-gallery-select]');
    if (!thumb || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const gallery = thumb.closest('[data-rs-gallery]');
    const buttons = [...gallery.querySelectorAll('[data-rs-gallery-select]')];
    const direction = event.key === 'ArrowLeft' ? -1 : 1;
    let index = (buttons.indexOf(thumb) + direction + buttons.length) % buttons.length;
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = buttons.length - 1;
    event.preventDefault();
    buttons[index].focus({ preventScroll: true });
    buttons[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
    rsSelectGallery(gallery, buttons[index].dataset.rsGallerySelect, true);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-rs-variant-select]')) return;
    const gallery = event.target.closest('[data-rs-product]')?.querySelector('[data-rs-gallery]');
    if (gallery) rsGalleryVariant(gallery, event.target.selectedOptions[0]?.dataset.mediaId || '');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-product-resources"] && !Shopify.designMode) return;
  try {
    function rsUpdateProductResources(productSection, announce = false) {
  const panel = productSection.querySelector('[data-rs-product-resources]');
  if (!panel) return;
  const view = panel.querySelector('[data-rs-resources-view]');
  if (!view) return;
  const selector = productSection.querySelector('[data-rs-variant-select]');
  const variantId = selector ? selector.value : panel.dataset.initialVariant;
  const selected = /^[1-9]\d{0,19}$/.test(variantId || '') && Array.from(panel.querySelectorAll('template[data-rs-resource-variant]')).find(item => item.dataset.rsResourceVariant === variantId);
  const template = selected || panel.querySelector('template[data-rs-resources-fallback]');
  if (!template) return;
  view.replaceChildren(template.content.cloneNode(true));
  if (announce) {
    const status = panel.querySelector('[data-rs-resources-status]');
    if (status) status.textContent = view.querySelector('[data-rs-resource-label]')?.dataset.rsResourceLabel || panel.dataset.fallbackLabel || '';
  }
}
function rsInitializeProductResources(root) {
  root.querySelectorAll('[data-rs-product]').forEach(product => rsUpdateProductResources(product));
}
rsInitializeProductResources(document);
document.addEventListener('shopify:section:load', event => rsInitializeProductResources(event.target));
document.addEventListener('change', event => {
  const selector = event.target.closest('[data-rs-variant-select]');
  const product = selector?.closest('[data-rs-product]');
  if (product) rsUpdateProductResources(product, true);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-product-sheet-reference"] && !Shopify.designMode) return;
  try {
    function updateRehanProductSheet(scope) {
  if (!scope) return;
  var selector = scope.querySelector('[data-rs-variant-select]');
  if (!selector) return;
  var selected = selector.value;
  scope.querySelectorAll('[data-rs-sheet-reference]').forEach(function(reference) {
    var found = false;
    reference.querySelectorAll('[data-rs-sheet-variant]').forEach(function(panel) {
      var match = panel.dataset.rsSheetVariant === selected;
      panel.hidden = !match;
      if (match) found = true;
    });
    reference.hidden = !found;
  });
}
document.addEventListener('change', function(event) {
  if (event.target.matches('[data-rs-variant-select]')) updateRehanProductSheet(event.target.closest('[data-rs-product]'));
});
document.querySelectorAll('[data-rs-product]').forEach(updateRehanProductSheet);
document.addEventListener('shopify:section:load', function(event) {
  event.target.querySelectorAll('[data-rs-product]').forEach(updateRehanProductSheet);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-resource-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = value => String(value || '').toLowerCase().replace(/[áéíóúñü]/g, letter => ({á:'a',é:'e',í:'i',ó:'o',ú:'u',ñ:'n',ü:'u'})[letter]).replace(/[\u0301\u0303\u0308]/g,'').replace(/[\t\n\r\f\v\u00a0\-.,/"&]/g,' ');
  const stopwords = new Set(['a','an','and','for','in','of','the','to','with']);
  const queryTokens = query => normalize(query).split(' ').filter(token => token && !stopwords.has(token));
  const matches = (corpus, tokens) => tokens.every(token => corpus.includes(token));
  const initialize = scope => {
    scope.querySelectorAll('[data-resource-discovery][data-resource-mode="search"]').forEach(root => {
      if (root.dataset.resourceReady) return;
      const parent = root.closest('.rs-library-search');
      const input = parent?.querySelector('[data-dir-search]');
      if (!input) return;
      root.dataset.resourceReady = 'true';
      const cards = [...root.querySelectorAll('[data-resource-card]')];
      const count = root.querySelector('[data-resource-count]');
      const empty = root.querySelector('[data-resource-empty]');
      const grid = root.querySelector('.rs-resource-discovery__grid');
      const controls = new Set((input.getAttribute('aria-controls') || '').split(' ').filter(Boolean));
      controls.add(grid.id);
      input.setAttribute('aria-controls', [...controls].join(' '));
      const update = () => {
        const query = input.value.trim().slice(0,160);
        const tokens = queryTokens(query);
        let total = 0;
        cards.forEach(card => {
          const show = tokens.length ? matches(card.dataset.resourceSearch, tokens) : card.dataset.resourceFeatured === 'yes';
          card.hidden = !show;
          if (show) total++;
        });
        count.hidden = tokens.length === 0;
        count.textContent = (total === 1 ? root.dataset.resourceCountSingle : root.dataset.resourceCountTemplate).replace('__COUNT__', String(total)).replace('__TERMS__', query);
        empty.hidden = total !== 0;
      };
      input.addEventListener('input', update);
      parent.addEventListener('click', event => { if (event.target.closest('[data-dir-reset]')) queueMicrotask(update); });
      window.addEventListener('popstate', () => queueMicrotask(update));
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
